import { render, staticRenderFns } from "./OrderThirdStepComponent.vue?vue&type=template&id=58cc3d2f"
import script from "./OrderThirdStepComponent.vue?vue&type=script&lang=js"
export * from "./OrderThirdStepComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderThirdStepComponent.vue?vue&type=style&index=0&id=58cc3d2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports